import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import { createId8Project } from '../../../redux/projects/projectsActions';
import validate from '../../../utils/validate';
import { createId8ProjectYopValidation } from '../validation';
import Id8CreationForm from './Id8CreationForm';
import { resetId8Agents } from '../../../redux/id8/id8Reducer';

function Id8Creation() {
  const dispatch = useDispatch();

  const createId8ProjectInitialValues = {
    projectName: '',
    instructions: '',
    assignUser: '',
    activeUsers: [],
    thinking: false,

    agentId: '',
    agentType: '',
    agentReferenceId: '',
  };

  const handleCreateProject = (values) => {
    dispatch(createId8Project(values));
  };

  useEffect(() => {
    return () => {
      dispatch(resetId8Agents());
    };
  }, [dispatch]);

  return (
    <Form
      initialValues={createId8ProjectInitialValues}
      onSubmit={handleCreateProject}
      validate={(values) => validate(values, createId8ProjectYopValidation())}
      subscription={{ submitting: true, pristine: true }}
      render={({ handleSubmit }) => <Id8CreationForm handleSubmit={handleSubmit} />}
    />
  );
}

export default Id8Creation;
